import $ from 'jquery'
import {Core} from "../../../assets/src/scripts/core.js";

export class BigSubmenu {

  constructor() {
    this.$container = $('.big-submenu')

    if (this.$container === undefined) {
      return
    }

    this.classes = {
      'title': 'big-submenu-title',
      'logo': 'big-submenu-logo',
      'scrollDown': 'scroll-down',
      'scrollUp': 'scroll-up',
      'submenuItemsOpen': 'open',
      'mobileOpenNav': 'open-nav',
    }

    this.$window = $(window)
    this.$body = $('body')
    this.$title = this.$container.find(`.${this.classes.title}`)
    this.$logo = this.$container.find(`.${this.classes.logo}`)
    this.$submenuItems = this.$container.find('ul li.menu-item-has-children')

    this.currentScroll = 0

    this.$window.on('load', this.handleScroll.bind(this))
    this.$window.on('resize', this.handleScroll.bind(this))
    this.$window.on('scroll', this.handleScroll.bind(this))
    this.$window.on('click', this.handleClickWindow.bind(this))

    this.$submenuItems.on('click', '> a', this.handleClickSubmenuItems.bind(this))

    // Mobile
    this.$title.on('click', this.handleClickTitle.bind(this))
  }

  handleScroll(e) {
    this.$container.removeClass(this.classes.mobileOpenNav)
    this.$submenuItems.removeClass(this.classes.submenuItemsOpen)
    let windowScrollTop = this.$window.scrollTop()

    if (Core.isBpGreaterThan('md')
      && this.$window.scrollTop() > 0
      && windowScrollTop > this.$container.offset().top
    ) {
      if (this.currentScroll < windowScrollTop) {
        this.$container.addClass(this.classes.scrollDown)
        this.$container.removeClass(this.classes.scrollUp)
      } else {
        this.$container.addClass(this.classes.scrollUp)
        this.$container.removeClass(this.classes.scrollDown)
      }
    } else {
      this.$container.removeClass(this.classes.scrollDown)
      this.$container.removeClass(this.classes.scrollUp)
    }

    this.currentScroll = windowScrollTop
  }

  handleClickTitle(e) {
    if ( Core.isBpLessThan('md') ) {
      e.preventDefault()
      this.$container.toggleClass(this.classes.mobileOpenNav)
    }
  }

  handleClickSubmenuItems(e) {
    e.preventDefault()
    let $li = $(e.target).closest('li')

    if ( $li.hasClass(this.classes.submenuItemsOpen) ) {
      $li.removeClass(this.classes.submenuItemsOpen)
      return
    }

    this.$submenuItems.removeClass(this.classes.submenuItemsOpen)
    $li.toggleClass(this.classes.submenuItemsOpen)
  }

  handleClickWindow(e) {
    let $item = $(e.target).closest('.big-submenu')

    if ( $item.length ) {
      return
    }

    this.$container.removeClass(this.classes.mobileOpenNav)
    this.$submenuItems.removeClass(this.classes.submenuItemsOpen)
  }
}
